import React from 'react';
import { ListWrapper } from '@builtbypixel/nucleus';
import setup from './setup';

const extraMenu = () => {
  return null;
};

const List = () => {
  const columns = [
    {
      Header: 'Campaign Title',
      accessor: 'campaign_title',
    },
    {
      Header: 'Emails Sent',
      accessor: 'emails_sent',
    },
    {
      Header: 'Abuse Reports',
      accessor: 'abuse_reports',
    },
    {
      Header: 'Unsubscribed',
      accessor: 'unsubscribed',
    },
  ];

  return (
    <ListWrapper
      setup={setup}
      columns={columns}
      extraMenu={extraMenu}
    />
  );
};

export default List;
